const SUPPLEMENTARY_DEFAULT = [
    "CFSD15",
    "CSD26",
    "CSFSD05",
    "DWDSD20",
    "EDSD33",
    "ELSD38",
    "ES&SSD27",
    "ESD25",
    "EWOSD30",
    "EWSD29",
    "EWSD32",
    "EWVSD31",
    "FCSD09",
    "FESD16",
    "FGABSD06",
    "FJSD08",
    "FSD14",
    "FSSD24",
    "FTSD07",
    "HESD35",
    "HOSD36",
    "HV&ASD23",
    "IASD28",
    "IDSD12",
    "IPSD10",
    "IWSD11",
    "LAGSUSD37",
    "PESD17",
    "PSPSSD22",
    "RESD18",
    "RSD34",
    "SDSPSSD21",
    "SESD19",
    "SEWSD03",
    "SFSD01",
    "SFSD02",
    "SSD04",
    "WFSD13"
  ]
export { SUPPLEMENTARY_DEFAULT };
